import React from 'react';

type TStepProps = {
    className?: string;
}

export default function Step({
    className = '',
}: TStepProps) {

    return (
        <div className={`step-container ${className}`}>
            <div className="step status-active">
                <span className="step-icon" />
                <h3 className="step-name visible-xs">Post</h3>
                <h3 className="step-name hidden-xs">Post</h3>
            </div>
            <div className="step">
                <span className="step-icon" />
                <h3 className="step-name visible-xs">Match</h3>
                <h3 className="step-name hidden-xs">Get matched</h3>
            </div>
            <div className="step">
                <span className="step-icon" />
                <h3 className="step-name visible-xs">Rate</h3>
                <h3 className="step-name hidden-xs">Confirmation</h3>
            </div>
        </div>
    );
}
